import React, { useState } from "react"
import { Col, Button, Modal, Form } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useFormikContext } from "formik"

import guideIcons from "../constants/guideIcons"
import IonIcon from "./ionIcon"

interface IconPickerProps {
  name: string
  values: { icon: string }
}

const IconPicker = ({ name, values }: IconPickerProps) => {
  const [display, setDisplay] = useState(false)
  const { t } = useTranslation()
  const { setFieldValue } = useFormikContext()

  const selectIcon = (item: { icon: string }) => {
    setFieldValue(name, item.icon)
    setDisplay(false)
  }

  const isSelected = (item: { icon: string }) => values.icon === item.icon

  return (
    <Col xs={12}>
      <Form.Text className="text-muted">{t("guides.modal.selectIcon")}</Form.Text>

      <Modal show={display} onHide={() => setDisplay(false)} backdrop={false} animation={false}>
        <Modal.Header>
          <Modal.Title>{t("guides.modal.selectIcon")}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="overflow-auto icon-picker-modal">
          {guideIcons.map(value => (
            <Button
              key={value.icon}
              variant="outline-primary"
              onClick={() => selectIcon(value)}
              className={"icon-picker-button" + (isSelected(value) ? " selected" : "")}>
              <IonIcon name={value.icon} className="icon-picker-icon" />
            </Button>
          ))}
        </Modal.Body>
      </Modal>

      <Button variant="secondary-link" className="icon-picker" onClick={() => setDisplay(true)}>
        <IonIcon name={values.icon} style={{ fontSize: 38, borderWidth: 0 }} />
      </Button>
    </Col>
  )
}

export default IconPicker
